module.exports = __webpack_public_path__ + "img/2.8668a3d0.svg";